<template>
  <div class="index">
    <HeaderComponent/>
    <SwiperComponents/>
    <AboutComponent/>
    <ProjectComponentIndex/>
    <ServiceComponent/>
    <FooterComponent/>
    <BackToTop :visibility-height="500" :bottom="50" :right="50"/>
  </div>
</template>

<script>
import HeaderComponent from '../components/HeaderComponent'
import FooterComponent from '../components/FooterComponent'
import AboutComponent from '../components/AboutComponent'
import SwiperComponents from '../components/SwiperComponents'
import ServiceComponent from '../components/ServiceComponent'
import ProjectComponentIndex from '../components/ProjectComponentIndex'


export default {
  name: "index",
  components: {
    HeaderComponent,
    FooterComponent,
    AboutComponent,
    SwiperComponents,
    ProjectComponentIndex,
    ServiceComponent,
  },
  data(){
    return{

    }
  },

}
</script>

<style scoped>
.index {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue